module.exports = __webpack_public_path__ + "static/privacypolicybanner-a27af866b69c07b831d31ff143ff5424.png";